import Vue from 'vue'

const COMPANYCATEGORY_SET_NAME =(state, payload)=> {
            
    state.data.name = payload
};


const COMPANYCATEGORY_SET_DUPLICATE =(state, payload)=> {
            
    state.data.duplicate = payload
};

const COMPANYCATEGORY_SET_COMPANYCATEGORIES =(state, payload)=> {  
    
    state.companycategories=payload
    
};

const COMPANYCATEGORY_SET_COMPANYCATEGORY =(state, payload)=> {       
    
    state.data.name = payload.name
        
};

const COMPANYCATEGORY_INIT_COMPANYCATEGORY =(state, payload)=> {       
    state.data.name = ''    
    
};



export default {
    COMPANYCATEGORY_SET_NAME,
    COMPANYCATEGORY_SET_DUPLICATE,
    COMPANYCATEGORY_SET_COMPANYCATEGORIES,
    COMPANYCATEGORY_SET_COMPANYCATEGORY,
    COMPANYCATEGORY_INIT_COMPANYCATEGORY,
};